import React from "react";
import PropTypes from "prop-types";

const ImaginationAndCreativityIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 292 292"
      fill={props.fill}
      style={props.style}
    >
      <rect width={props.width} height={props.height} fill="#EBFCFF" />
      <path
        d="M192.772 134.497C192.772 134.497 201.037 148.62 202.04 152.833C203.043 157.086 208.941 166.434 211.068 169.122C213.194 171.81 216.845 178.431 215.08 182.964C212.793 188.822 205.932 189.103 201.238 190.226C196.584 191.35 190.445 192.313 190.445 192.313L182.982 172.533L192.772 134.497Z"
        fill="#6BDEEF"
      />
      <path
        d="M141.537 123.625C141.537 123.625 124.485 124.789 121.396 126.233C118.266 127.677 118.066 128.921 115.498 130.807C112.89 132.693 112.168 132.452 109.6 135.461C106.992 138.47 103.06 141.68 100.251 142.522C97.4429 143.365 95.156 143.887 92.7888 144.93C90.4216 145.973 86.4495 145.13 84.4836 147.738C82.5176 150.346 76.3789 154.679 76.3789 158.009C76.3789 161.34 77.7431 167.559 85.8076 170.247C93.9122 172.935 99.9305 171.691 100.974 171.169C102.017 170.648 106.27 165.793 106.27 165.793C106.27 165.793 114.174 161.019 119.029 163.506L137.204 149.584L141.537 123.625Z"
        fill="#6BDEEF"
      />
      <path
        d="M117.222 159.976C117.222 159.976 117.022 169.805 117.543 175.864C118.065 181.922 113.611 211.452 113.611 211.452C113.611 211.452 129.179 220.8 153.252 220.76C173.513 220.72 188.88 211.051 188.88 211.051V185.012L117.222 159.976Z"
        fill="#6BDEEF"
      />
      <path
        d="M194.418 152.954C194.418 152.954 195.34 144.729 195.1 141.84C194.859 138.952 193.134 132.291 187.557 129.242C183.384 126.995 171.388 123.625 171.388 123.625H141.537L127.173 151.831L118.988 163.466L121.115 190.388L181.699 191.19L194.418 152.954Z"
        fill="#6BDEEF"
      />
      <path
        d="M141.095 123.665C141.095 123.665 140.734 134.337 142.499 138.711C144.265 143.084 147.715 150.025 155.418 149.865C164.285 149.664 170.063 140.195 171.668 137.106C173.273 134.057 175.64 127.798 175.64 127.798L141.095 123.665Z"
        fill="#D1905E"
      />
      <path
        d="M151.648 92.4906C151.648 92.4906 144.105 98.5089 143.102 104.607C142.099 110.706 140.615 119.573 140.815 122.101C141.016 124.628 143.664 131.609 145.79 134.338C147.917 137.106 153.213 140.035 158.028 139.433C163.324 138.751 165.892 137.066 169.543 134.619C173.194 132.171 176.885 126.153 179.132 121.178C181.379 116.203 184.628 105.61 184.428 103.765C184.227 101.919 177.406 92.5708 171.91 92.0492C166.413 91.6079 156.222 89.9629 151.648 92.4906Z"
        fill="#EEAF7C"
      />
      <path
        d="M143.102 104.607C143.102 104.607 142.018 101.477 140.052 101.357C138.086 101.236 137.605 104.566 137.966 107.495C138.327 110.424 137.846 113.393 138.407 114.557C138.969 115.72 140.494 118.007 141.938 116.884C143.342 115.801 143.102 104.607 143.102 104.607Z"
        fill="#EEAF7C"
      />
      <path
        d="M180.093 117.566C180.093 117.566 182.701 114.115 184.948 115.359C187.395 116.723 186.312 121.297 183.102 123.584C179.892 125.871 180.253 127.637 177.766 128.279C175.278 128.92 175.639 126.072 175.639 126.072L180.093 117.566Z"
        fill="#EEAF7C"
      />
      <path
        d="M123.441 148.019C123.441 148.019 124.324 143.565 126.852 143.204C129.379 142.883 129.179 149.182 129.179 149.182L123.441 148.019Z"
        fill="#05B2C7"
      />
      <path
        d="M130.383 149.463C130.383 149.463 135.92 151.028 136 150.747C136 150.747 137.123 147.939 135.88 145.933C134.435 143.485 131.466 145.933 130.383 149.463Z"
        fill="#05B2C7"
      />
      <path
        d="M135.438 152.955L132.228 172.735L125.448 171.611L122.92 150.347L135.438 152.955Z"
        fill="#6BDEEF"
      />
      <path
        d="M124.406 187.619C124.406 187.619 124.205 189.184 124.767 187.86C125.289 186.535 125.409 183.607 126.051 180.838C126.773 177.829 127.375 175.061 127.736 174.539H126.813L125.048 180.798L124.406 187.619Z"
        fill="#EBEBEB"
      />
      <path
        d="M125.246 172.854C125.246 172.854 123.962 187.257 124.043 187.739C124.364 189.665 124.885 187.338 124.885 187.338C124.885 187.338 125.607 175.622 127.132 174.579C128.657 173.536 125.768 188.662 127.012 188.662C127.533 188.662 127.934 184.168 129.178 178.832C130.342 173.977 130.823 171.811 130.823 171.811L125.246 172.854Z"
        fill="#F9F9F9"
      />
      <path d="M222.544 193.558H70V199.335H222.544V193.558Z" fill="#C28200" />
      <path
        d="M153.252 186.817C153.252 186.817 148.277 182.644 148.237 175.984C148.196 169.324 153.172 165.312 158.267 164.71C163.363 164.108 168.378 167.88 169.902 172.092C171.467 176.466 170.223 184.049 164.446 186.777H153.252V186.817Z"
        fill="#FFBB33"
      />
      <path
        d="M156.623 187.218C156.623 187.218 151.206 178.752 155.138 176.586C157.666 175.221 160.876 179.073 159.792 179.635C158.188 180.437 157.225 178.431 159.833 176.786C162.44 175.141 164.166 177.428 164.085 179.555C163.965 182.524 161.357 187.218 161.357 187.218H156.623Z"
        stroke="#FFF9EB"
        strokeWidth="0.352591"
        strokeMiterlimit="10"
      />
      <path
        d="M102.257 152.352C102.257 152.352 99.2884 149.865 98.5261 149.544C97.7236 149.223 91.1035 149.544 91.1035 149.544C91.1035 149.544 96.3193 147.778 98.0045 147.778C99.6896 147.778 104.705 149.142 106.229 152.834L102.257 152.352Z"
        fill="#26C7D9"
      />
      <path
        d="M121.035 148.941C121.035 148.941 120.634 142.642 121.677 140.435C122.72 138.269 122.72 133.855 122.72 133.855C122.72 133.855 123.964 138.911 123.442 141.398C122.921 143.846 123.562 149.262 123.562 149.262L121.035 148.941Z"
        fill="#26C7D9"
      />
      <path
        d="M97.9668 189.024C101.417 188.222 109.522 189.024 112.852 190.228C116.182 191.431 141.78 192.434 146.755 190.147C151.73 187.861 152.894 187.941 152.894 187.941H164.168C164.168 187.941 171.029 189.465 173.557 188.061"
        stroke="#484848"
        strokeWidth="0.310423"
        strokeMiterlimit="10"
      />
      <path
        d="M149.722 99.3509C149.722 99.3509 149.441 96.422 151.487 95.5795C153.493 94.7369 151.848 97.4251 152.29 97.6658C152.731 97.9065 153.975 100.715 154.537 98.8293C155.098 96.9436 156.222 95.2986 157.064 95.7399C157.907 96.1813 155.58 98.1874 157.024 98.5485C158.469 98.9096 159.632 101.237 160.274 101.598C160.916 101.959 160.515 100.715 160.916 101.959C161.317 103.203 161.879 102.922 161.718 103.283C161.558 103.644 163.083 105.249 163.484 104.527C163.885 103.804 163.163 102.842 164.126 101.959C165.089 101.076 167.777 98.8695 167.897 100.113C167.977 101.357 166.292 103.042 167.376 103.804C168.459 104.567 169.181 106.733 169.863 106.453C170.545 106.172 172.03 105.57 172.391 104.406C172.752 103.243 173.033 101.277 174.638 101.558C176.243 101.838 176.684 102.561 177.727 102.601C178.77 102.681 177.246 103.965 177.767 105.088C178.289 106.212 178.449 108.619 178.449 108.619L182.14 110.585C182.14 110.585 182.823 107.175 183.826 107.335C184.829 107.456 184.989 109.261 185.109 107.135C185.23 105.008 184.949 104.727 185.912 104.446C186.875 104.166 186.875 104.166 186.875 104.166C185.792 105.65 186.875 104.166 186.875 104.166C187.958 102.681 185.31 105.409 187.958 102.681C190.606 99.9527 190.085 99.9126 190.165 98.9096C190.205 97.9065 191.248 96.3016 191.168 95.8603C191.088 95.419 191.93 93.2524 191.328 92.6907C190.767 92.129 191.128 89.842 190.967 89.2001C190.807 88.5581 191.248 87.3143 191.048 86.1107C190.847 84.907 187.316 85.4687 186.714 84.5058C186.153 83.5429 189.523 86.0304 184.066 80.6541C178.65 75.2376 184.548 78.8085 184.548 78.8085L182.06 76.5215C182.06 76.5215 178.65 76.1604 178.048 76C177.446 75.8395 176.523 74.6759 175.32 74.1544C174.116 73.6328 173.073 71.3057 171.227 71.2656C169.382 71.2254 169.462 73.392 168.258 73.5926C167.055 73.7932 166.653 71.4261 165.289 71.5063C163.925 71.5865 160.876 70.7039 160.956 71.1051C161.036 71.5464 163.002 73.2717 161.397 73.4723C159.793 73.6729 157.666 70.6637 156.984 71.747C156.302 72.8303 154.296 75.0772 153.052 75.8796C151.808 76.682 148.719 75.4784 148.719 75.4784C148.719 75.4784 146.954 75.5586 147.756 76.4814C148.558 77.4042 150.123 76.5617 149.521 77.645C148.92 78.7282 147.234 78.7282 146.713 79.4103C146.191 80.0924 144.667 81.6572 144.145 82.0985C143.623 82.5398 142.259 83.8639 142.901 84.5459C143.543 85.228 143.704 84.9471 143.583 87.1137C143.463 89.2402 140.975 88.9192 141.898 90.484C142.821 92.0487 142.781 94.7369 143.142 94.4962C143.503 94.2956 143.944 93.774 144.426 95.5795C144.907 97.3849 146.673 97.746 146.673 97.746L149.722 99.3509Z"
        fill="#483000"
      />
      <path
        d="M182.984 104.888C182.984 104.888 180.496 116.724 180.697 117.406C180.898 118.048 184.91 106.252 184.99 105.289C185.03 104.286 182.984 104.888 182.984 104.888Z"
        fill="#483000"
      />
      <path
        d="M145.067 93.895C145.067 93.895 142.82 103.564 143.061 104.648C143.302 105.731 149.561 93.6543 149.561 93.6543L145.067 93.895Z"
        fill="#483000"
      />
      <path
        d="M95.5561 169.123C95.5561 169.123 88.5749 164.349 93.0685 156.525C93.0685 156.525 95.195 152.152 103.58 152.352C112.006 152.553 116.821 149.825 116.821 149.825C116.821 149.825 121.836 147.899 123.441 148.019C125.006 148.139 135.999 150.788 135.999 150.788C135.999 150.788 139.048 152.312 139.449 153.997C139.891 155.642 138.808 157.849 135.477 157.287C132.147 156.766 128.697 155.482 127.573 155.522C126.45 155.562 123.16 154.599 123.16 154.599C123.16 154.599 126.851 156.244 128.897 156.806C130.944 157.368 136.842 158.852 138.406 159.173C139.931 159.494 141.014 159.213 141.656 159.534C142.298 159.855 143.462 161.821 142.539 163.466C141.616 165.111 138.968 164.991 138.166 164.87C137.403 164.75 133.351 164.188 132.749 164.148C132.187 164.068 123.441 161.62 123.441 161.62L131.866 165.191C131.866 165.191 136.922 165.994 138.607 165.913C140.252 165.833 141.817 166.074 142.378 167.558C142.94 169.043 141.536 170.568 140.372 170.848C139.209 171.129 131.826 170.929 130.021 170.447C128.215 170.006 121.194 167.478 121.194 167.478C121.194 167.478 127.814 171.129 128.897 171.21C129.981 171.29 133.913 171.129 134.835 171.49C135.758 171.852 137.203 173.216 136.641 174.339C136.039 175.462 129.62 175.824 128.777 175.743C127.934 175.703 118.987 173.176 117.944 172.694C116.901 172.213 111.364 170.568 110.16 169.565C108.957 168.562 106.75 167.238 103.781 168.04C100.892 168.923 98.2443 169.364 95.5561 169.123Z"
        fill="#EEAF7C"
      />
      <path
        d="M183.103 182.323C183.103 182.323 182.862 171.008 183.103 168.12C183.344 165.231 184.387 148.701 183.665 142.803C183.665 142.803 187.155 152.673 186.634 158.691C186.112 164.669 185.872 181.199 185.872 181.199L184.828 183.687L183.103 182.323Z"
        fill="#26C7D9"
      />
      <path
        d="M184.869 173.255C184.869 173.255 186.514 167.879 187.477 165.632C188.44 163.385 194.699 157.447 194.699 157.447C194.699 157.447 189.002 165.351 188.881 167.678C188.761 170.005 188.881 173.255 188.881 173.255C188.881 173.255 196.103 171.45 197.227 171.089C198.35 170.728 205.331 172.292 206.736 172.734C206.736 172.734 201.68 172.413 199.875 172.774C198.069 173.135 185.511 174.298 185.511 174.298L184.869 173.255Z"
        fill="#26C7D9"
      />
      <path
        d="M192.571 177.147C192.571 177.187 192.571 177.228 192.571 177.268C192.571 177.268 194.176 180.919 194.176 183.005C194.176 185.091 194.136 187.298 192.571 188.983C192.571 188.983 192.45 192.715 188.478 193.678C184.506 194.64 173.553 188.02 173.553 188.02C173.553 188.02 171.587 187.017 172.791 184.971C172.791 184.971 167.214 181.801 171.627 179.795C171.627 179.795 171.106 176.144 174.917 176.746L177.886 177.147C177.886 177.147 176.001 175.342 178.207 174.218C180.414 173.095 184.145 173.336 185.67 173.215C186.232 173.175 186.994 173.015 187.756 172.854C190.404 172.212 192.932 174.419 192.571 177.147Z"
        fill="#EEAF7C"
      />
      <path
        d="M172.752 184.972C172.752 184.972 179.894 188.904 180.897 188.984C181.9 189.064 188.881 188.984 188.881 188.984"
        stroke="#D1905E"
        strokeWidth="0.401219"
        strokeMiterlimit="10"
      />
      <path
        d="M171.59 179.795C171.59 179.795 173.195 181.36 176.926 182.563C180.657 183.767 184.71 184.81 186.154 184.61C187.598 184.409 189.404 184.409 189.404 184.409"
        stroke="#D1905E"
        strokeWidth="0.401219"
        strokeMiterlimit="10"
      />
      <path
        d="M177.848 177.147C177.848 177.147 182.783 178.712 183.344 178.913C183.906 179.154 188.881 178.913 188.881 178.913"
        stroke="#D1905E"
        strokeWidth="0.401219"
        strokeMiterlimit="10"
      />
      <path
        d="M164.408 186.817H153.254V189.024H164.408V186.817Z"
        fill="#B0B0B0"
      />
      <path
        d="M164.408 189.023H153.254V191.23H164.408V189.023Z"
        fill="#717171"
      />
      <path
        d="M164.408 191.23H153.254V193.437H164.408V191.23Z"
        fill="#B0B0B0"
      />
      <path
        d="M99.6896 193.558H91.1035V186.938C91.1035 184.57 93.0293 182.645 95.3965 182.645C97.7637 182.645 99.6896 184.57 99.6896 186.938V193.558Z"
        fill="#FFAB00"
      />
    </svg>
  );
};

ImaginationAndCreativityIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

ImaginationAndCreativityIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default ImaginationAndCreativityIllustration;
